import $ from "jquery";
import anime from "animejs";

var $loader = $();
var $home = $();

export function load() {
    $loader = $('#loader');
    $home = $('.fullpage--home');
    if ($loader.length) {
        startLoadAnimation();
    } else {
        if ($home.length) startHomeAnimation();
    }
}

function startHomeAnimation() {

    var $bg = $('.fullpage-bg');
    var $buttons = $home.find('.button');
    $bg.css('transform', 'scale(1.015) rotateY(0)');
    $('.loader-bg').css('transform', 'scale(1.015)');

    $home.on('mousemove', function(event) {
        var x = event.pageX;
        var totalWidth = this.offsetWidth;
        var position = event.pageX / this.offsetWidth;
        var degrees;
        degrees = position - 0.5;
        $bg.css('transform', 'scale(1.015) rotateY('+degrees+'deg)');
        $buttons.filter(function(i,el) { if ($(el).children('.button-marker--left').length) return true}).css('transform-origin', 'left center');
        $buttons.filter(function(i,el) { if ($(el).children('.button-marker--right').length) return true}).css('transform-origin', 'right center');
        $buttons.css('transform', 'rotateY('+degrees*-4+'deg)');
    });
}

function startLoadAnimation() {
    
    $loader.show();
    $('body').css('overflow', 'hidden');

    var tl = anime.timeline({
        easing: 'easeOutSine',
        complete:  function() {
            $loader.hide();
            $('body').css('overflow', 'auto');
            if ($home.length) startHomeAnimation();
        }
    });

    tl.add({
        targets: '.loader-logo .logo-text',
        easing: 'easeInSine',
        scale: [0,1],
        duration: 500
    }, 3500);

    tl.add({
        targets: '.loader-logo',
        easing: 'easeInSine',
        scale: [1,1],
        duration: 1500
    }, 3500);

    tl.add({
        targets: '.loader-bg--2',
        opacity: [0,1],
        duration: 3000
    }, 500);

    tl.add({
        targets: '.loader-bg--3',
        scale: 1.15,
        duration: 0
    });

    tl.add({
        targets: '.loader-bg--3',
        opacity: [0,1],
        duration: 1500
    }, 4500);

    tl.add({
        targets: '.loader-logo .logo-path',
        stroke: '#ffffff',
        easing: 'easeInOutSine',
        duration: 500
    }, 4500);

    tl.add({
        targets: '.loader-logo .logo-text',
        fill: '#ffffff',
        easing: 'easeInOutSine',
        duration: 500
    }, 4500);

    tl.add({
        targets: '.loader-logo',
        opacity: [1,0],
        duration: 1000
    }, 5000);

    tl.add({
        targets: '.loader-logo .logo-path',
        strokeDashoffset: [anime.setDashoffset, 0],
        duration: 4000
    }, 500);

    tl.add({
        targets: '#loader',
        opacity: [1,0],
        duration: 1000
    }, 6000);

    tl.add({
        targets: '.loader-bg--3, .fullpage--home .fullpage-bg',
        scale: [1.15,1],
        duration: 2500
    }, 4500);
}
